export default "__VITE_PUBLIC_ASSET__61234785__"